import DataObjectField from "@/utilities/classes/data-object-field";

const buildCreateMIHTenantCertificationObject = (vData, LeaseFile, LeaseName, AcknowledgementCertFile, AcknowledgementCertName, Section8VoucherFile, Section8VoucherName) => {

    const fields = [
    new DataObjectField(vData.FullApplication.RelatedUnit, 6),
    new DataObjectField(vData.FullApplication.Certification, 7),
    new DataObjectField(vData.FullApplication.NumOfBedrooms, 8),
    new DataObjectField(vData.FullApplication.UnitOccupationDate, 9),
    new DataObjectField(vData.FullApplication.Section8Voucher, 10),
    {
        _fid: "11",
        _filename: LeaseName,
        __text: LeaseFile,
    },
    {
        _fid: "12",
        _filename: AcknowledgementCertName,
        __text: AcknowledgementCertFile,
    },
    {
        _fid: "13",
        _filename: Section8VoucherName,
        __text: Section8VoucherFile,
    },
    new DataObjectField(vData.FullApplication.GrossRentLimit, 31),
    new DataObjectField(vData.FullApplication.RentCharged, 32),
  ];

  if(vData.FullApplication.Section8Voucher == 'No'){
        fields.push(new DataObjectField(vData.FullApplication.TenantGas, 14));
        fields.push(new DataObjectField(vData.FullApplication.HeatingPower, 15));
        fields.push(new DataObjectField(vData.FullApplication.StovePower, 16));
        fields.push(new DataObjectField(vData.FullApplication.WaterHeatingPower, 17));
        fields.push(new DataObjectField(vData.FullApplication.TenantElectric, 18));
        fields.push(new DataObjectField(vData.FullApplication.TenantWater, 19));
        fields.push(new DataObjectField(vData.FullApplication.TenantSewer, 20));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Electric Charge')[0].cost, 21));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Gas Charge')[0].cost, 22));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Other Electric (Lights & Appliances)')[0].cost, 23));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Air Conditioning')[0].cost, 24));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Heating')[0].cost, 25));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Cooking')[0].cost, 26));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Water Heating')[0].cost, 27));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Water')[0].cost, 28));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Sewer')[0].cost, 29));
        fields.push(new DataObjectField(vData.FullApplication.UtilityAllowanceItems.filter(e => e.name == 'Total')[0].cost, 30));
    }

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_MIH_TENANT_CERTIFICATION",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      clist: "3",
      field: fields
    }
  };
  return dataObject;
};

export default buildCreateMIHTenantCertificationObject;